<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { helpers } from "../../../../helpers/helpers-validate";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
import MaskedInput from "vue-text-mask";
Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * Departamento component
 */
export default {
  page: {
    title: "Proveedores",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "proveedores/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_proveedor: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Proveedores",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Proveedores",
          active: true,
        },
      ],
      fields: [
        {
          name: "company_proveedor",
          title: "Nombre de la empresa",
          sortField: "company_proveedor",
          width: "15%",
        },

        {
          name: "nit_proveedor",
          title: "Nit",
          sortField: "nit_proveedor",
          width: "10%",
        },

        {
          name: "persona.numero_persona",
          title: "Teléfono proveedor",
          sortField: "persona.numero_persona",
          width: "10%",
        },

        {
          name: "direccion_proveedor",
          title: "Dirección",
          sortField: "direccion_proveedor",
          width: "10%",
        },
        {
          name: "persona.nombre_persona",
          title: "Nombre del contacto",
          sortField: "persona.nombre_persona",
          width: "20%",
        },
        {
          name: "telefono_proveedor",
          title: "Teléfono representante",
          sortField: "telefono_proveedor",
          width: "10%",
        },
        {
          name: "persona.email_persona",
          title: "Correo",
          sortField: "persona.email_persona",
          width: "10%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_departamento",
      sortDesc: false,
      searchLabel: { nombre: "Nombre", value: "nombre" },
      filterLabel: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formPro: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
      telefono_proveedor: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      const { nombre, telefono, compania, direc, telefono_proveedor, nit } = this.formPro;
      /*  if (this.$v.$invalid ) { */
      let telC = 0;
      let telC2 = 0;
      for (let i = 0; i < telefono.length; i++) {
        if (telefono[i] === "_") {
          telC++;
        }
      }

      for (let i = 0; i < telefono_proveedor.length; i++) {
        if (telefono_proveedor[i] === "_") {
          telC2++;
        }
      }

      if (nombre === "" || telC !== 0 ||  telC2 !== 0 || compania === "" || direc === "" || nit =="" ) {
        Vue.toasted.error("Complete los datos de proveedor", this.options);
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formPro;
      axios
        .put(
          process.env.VUE_APP_URL + "proveedores/desactivate",
          {
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formPro;
      axios
        .put(
          process.env.VUE_APP_URL + "proveedores/activate",
          {
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    //Guardar registro
    save() {
      const {
        nombre,
        nit,
        direccion,
        telefono,
        correo,
        cui,
        compania,
        telefono_proveedor,
        direc,
      } = this.formPro;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "proveedores/store",
          {
            nombre,
            nit,
            direccion,
            telefono_proveedor,
            numero: telefono,
            email: correo,
            cui,
            compania,
            direc,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          me.$refs.vuetable.refresh();
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const {
        nombre,
        nit,
        direccion,
        telefono,
        correo,
        cui,
        compania,
        direc,
        telefono_proveedor,
        id,
      } = this.formPro;
      const me = this;
      axios
        .put(
          process.env.VUE_APP_URL + "proveedores/update",
          {
            id: id,
            nombre,
            nit,
            direccion,
            numero: telefono,
            telefono_proveedor,
            email: correo,
            cui,
            compania,
            direc,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Actualizado", this.options);
          me.$refs.vuetable.refresh();
          this.showModalE = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formPro.id = 0;
      this.formPro.telefono = "";
      this.formPro.nombre = "";
      this.formPro.nit = "C/F";
      this.formPro.direccion = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formPro.nombre = data.persona.nombre_persona;
        this.formPro.apellido = data.persona.apellido_persona;
        this.formPro.nit = data.nit_proveedor;
        this.formPro.direccion = data.persona.direccion_persona;
        this.formPro.telefono = data.persona.numero_persona;
        this.formPro.correo = data.persona.email_persona;
        this.formPro.cui = data.persona.cui_persona;
        this.formPro.sexo = data.persona.sexo_persona;
        this.formPro.compania = data.company_proveedor;
        this.formPro.direc = data.direccion_proveedor;
        this.formPro.state = data.estado_proveedor;
        this.formPro.id = data.persona.id;
        this.formPro.telefono_proveedor = data.telefono_proveedor;
        // console.log(data.id)
      }
      if (action == "new-item") {
        this.formPro.nombre = "";
        this.formPro.apellido = "";
        this.formPro.nit = "";
        this.formPro.direccion = "";
        this.formPro.telefono = "";
        this.formPro.correo = "";
        this.formPro.cui = "";
        this.formPro.sexo = "";
        this.formPro.telefono_proveedor = "";
        this.formPro.compania = "";
        this.formPro.direc = "";
      }
      if (action == "desactivate-item") {
        this.formPro.nombre = data.persona.nombre_persona;
        this.formPro.id = data.persona.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formPro.nombre = data.persona.nombre_persona;
        this.formPro.id = data.persona.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar Departamento"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Activar el Proveedor {{ this.formPro.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Desactivar al Proveedor {{ this.formPro.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          ref="modalUpdate"
          id="modalUpdate"
          title="Editar Proveedor"
          no-close-on-backdrop
          v-model="showModalE"
          @hidden="closeModal('update')"
          @show="openModal('uptade')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Datos de la empresa</span
                  >
                </template>

                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Nombre de la empresa</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.compania.$model"
                      :state="!$v.formPro.compania.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Nombre"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.compania.$error &&
                          !$v.formPro.compania.required,
                      }"
                    >
                      Nombre Requerido.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Dirección de la empresa</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.direc.$model"
                      :state="!$v.formPro.direc.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Dirección"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.direc.$error && !$v.formPro.direc.required,
                      }"
                    >
                      Dirección Requerido.
                    </div>
                  </div>
                </div>
                <!-- Nit -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Nit</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.nit.$model"
                      :class="{ 'is-invalid': $v.formPro.nit.$error }"
                      type="text"
                      class="form-control"
                      placeholder="C/F"
                      @input="$v.formPro.nit.$touch()"
                    />
                    <div v-if="$v.formPro.nit.$error">
                      <div
                        class="alert alert-danger"
                        v-if="!$v.formPro.nit.nit"
                      >
                        El número de NIT no es valido.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Teléfono</label>
                    <masked-input
                      v-model.trim="formPro.telefono"
                      :class="{
                        'is-invalid': $v.formPro.telefono.$error,
                      }"
                      :state="!$v.formPro.telefono.$error"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        '-',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese el número de teléfono"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.telefono.$error &&
                          !$v.formPro.telefono.required,
                      }"
                    >
                      Telefono Requerido
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="correo">Correo</label>
                    <input
                      id="correo"
                      v-model.trim="formPro.correo"
                      :state="!$v.formPro.correo.$error"
                      type="email"
                      class="form-control"
                      placeholder="Ingrese Correo"
                      @input="$v.formPro.correo.$touch()"
                    />
                    <div v-if="$v.formPro.correo.$error">
                      <div
                        class="alert alert-danger"
                        v-if="!$v.formPro.correo.correo"
                      >
                        Correo invalido.
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Datos del representante</span
                  >
                </template>

                <!-- Nombre -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Nombre del contacto</label>
                    <input
                      id="name"
                      v-model="$v.formPro.nombre.$model"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese un nombre"
                      :class="{
                        'is-invalid': $v.formPro.nombre.$error,
                      }"
                      @input="$v.formPro.nombre.$touch()"
                    />
                    <div
                      v-if="
                        $v.formPro.nombre.$error && !$v.formPro.nombre.required
                      "
                      class="invalid-feedback"
                    >
                      El nombre es obligatorio.
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Teléfono</label>
                    <masked-input
                      v-model.trim="formPro.telefono_proveedor"
                      :class="{
                        'is-invalid': $v.formPro.telefono_proveedor.$error,
                      }"
                      :state="!$v.formPro.telefono_proveedor.$error"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        '-',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese el número de teléfono"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.telefono_proveedor.$error &&
                          !$v.formPro.telefono_proveedor.required,
                      }"
                    >
                      Telefono Requerido
                    </div>
                  </div>
                </div>
                <!-- Identificacion -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Identificación</label>
                    <masked-input
                      v-model.trim="formPro.cui"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese Cui"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Dirección del contacto</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.direccion.$model"
                      :state="!$v.formPro.direccion.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Dirección"
                    />
                  </div>
                </div>
              </b-tab>
            </b-tabs>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('update')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
          centered
          @show="openModal('save')"
          @hidden="openModal('save')"
          v-model="showModalN"
          id="modalSave"
          ref="modalSave"
          title="Nuevo Proveedor"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Datos de la empresa</span
                  >
                </template>

                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Nombre de la empresa</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.compania.$model"
                      :state="!$v.formPro.compania.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Nombre"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.compania.$error &&
                          !$v.formPro.compania.required,
                      }"
                    >
                      Nombre Requerido.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Dirección de la empresa</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.direc.$model"
                      :state="!$v.formPro.direc.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Dirección"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.direc.$error && !$v.formPro.direc.required,
                      }"
                    >
                      Dirección Requerido.
                    </div>
                  </div>
                </div>
                <!-- Nit -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Nit</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.nit.$model"
                      :class="{ 'is-invalid': $v.formPro.nit.$error }"
                      type="text"
                      class="form-control"
                      placeholder="C/F"
                      @input="$v.formPro.nit.$touch()"
                    />
                    <div v-if="$v.formPro.nit.$error">
                      <div
                        class="alert alert-danger"
                        v-if="!$v.formPro.nit.nit"
                      >
                        El número de NIT no es valido.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Teléfono</label>
                    <masked-input
                      v-model.trim="formPro.telefono"
                      :class="{
                        'is-invalid': $v.formPro.telefono.$error,
                      }"
                      :state="!$v.formPro.telefono.$error"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        '-',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese el número de teléfono"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.telefono.$error &&
                          !$v.formPro.telefono.required,
                      }"
                    >
                      Telefono Requerido
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="correo">Correo</label>
                    <input
                      id="correo"
                      v-model.trim="formPro.correo"
                      :state="!$v.formPro.correo.$error"
                      type="email"
                      class="form-control"
                      placeholder="Ingrese Correo"
                      @input="$v.formPro.correo.$touch()"
                    />
                    <div v-if="$v.formPro.correo.$error">
                      <div
                        class="alert alert-danger"
                        v-if="!$v.formPro.correo.correo"
                      >
                        Correo invalido.
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Datos del representante</span
                  >
                </template>

                <!-- Nombre -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Nombre del contacto</label>
                    <input
                      id="name"
                      v-model="$v.formPro.nombre.$model"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese un nombre"
                      :class="{
                        'is-invalid': $v.formPro.nombre.$error,
                      }"
                      @input="$v.formPro.nombre.$touch()"
                    />
                    <div
                      v-if="
                        $v.formPro.nombre.$error && !$v.formPro.nombre.required
                      "
                      class="invalid-feedback"
                    >
                      El nombre es obligatorio.
                    </div>
                  </div>
                </div>
                <!-- Identificacion -->
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Identificación</label>
                    <masked-input
                      v-model.trim="formPro.cui"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese Cui"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Teléfono</label>
                    <masked-input
                      v-model.trim="formPro.telefono_proveedor"
                      :class="{
                        'is-invalid': $v.formPro.telefono_proveedor.$error,
                      }"
                      :state="!$v.formPro.telefono_proveedor.$error"
                      :mask="[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        '-',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]"
                      class="form-control"
                      placeholder="Ingrese el número de teléfono"
                    />
                    <div
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.formPro.telefono_proveedor.$error &&
                          !$v.formPro.telefono_proveedor.required,
                      }"
                    >
                      Telefono Requerido
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="phone">Dirección del contacto</label>
                    <input
                      id="phone"
                      v-model.trim="$v.formPro.direccion.$model"
                      :state="!$v.formPro.direccion.$error"
                      type="text"
                      class="form-control"
                      placeholder="Ingrese Dirección"
                    />
                  </div>
                </div>
              </b-tab>
            </b-tabs>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('save')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Proveedores</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      v-b-modal.modalSave
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Proveedor
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :http-options="httpOptions"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_proveedor"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      v-b-modal.modalUpdate
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_proveedor == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_proveedor == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_proveedor == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_proveedor == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
/* Contenedor general */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
  padding: 15px;
}

.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

/* Botones */
.btn-rounded {
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.btn-rounded:hover {
  transform: scale(1.05);
}

/* Tabla responsiva */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Desplazamiento suave en dispositivos táctiles */
}

.table-divided {
  width: 100%;
  border-collapse: collapse;
}

.table-divided th,
.table-divided td {
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;
  white-space: nowrap; /* Evita que el contenido se ajuste automáticamente */
}

/* Dropdown y inputs */
.dataTables_length,
.dataTables_filter {
  margin-bottom: 20px;
}

.dataTables_length select,
.dataTables_filter input {
  font-size: 0.9rem;
  padding: 5px 10px;
  border-radius: 5px;
}

/* Ajustes para tablets */
@media (max-width: 992px) {
  .card-title {
    font-size: 1.3rem;
  }

  .btn-rounded {
    font-size: 0.85rem;
    padding: 7px 15px;
  }

  .dataTables_length,
  .dataTables_filter {
    text-align: center;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.9rem;
    padding: 6px;
  }
}

/* Ajustes para móviles */
@media (max-width: 576px) {
  .card {
    padding: 10px;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .btn-rounded {
    font-size: 0.8rem;
    padding: 5px 10px;
  }

  .dataTables_length,
  .dataTables_filter {
    text-align: center;
    margin-bottom: 15px;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.8rem;
    padding: 4px;
  }
}
</style>
